module.exports = __webpack_public_path__ + "static/media/BY.4506d74f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BY.svg
// module id = 2122
// module chunks = 7